import i18next from 'i18next';

const namespace = 'lpMonitor';
const config = {
  zh: {},
  en: {
    title: 'LP Monitor',
    all: 'All',
    start_date: 'Start date',
    end_date: 'End date',
    placeholder_search: 'Search by LP/Account/File Name',
    btn_export: 'Export',
    to: 'To',
    lp_name: 'LP Name',
    lp_account: 'LP Account',
    user_activity: 'User Activity',
    time: 'Time',
    file_name: 'File Name',
    login: 'Login',
    download: 'Download',
  },
};

Object.keys(config).forEach((key) => {
  i18next.addResources(key, namespace, config[key]);
});
